import { BottomSheet } from '@new-components/elements';

import { Typography } from '@julo-ui/react';
import { useFormContext } from '@hooks/react-hook-form';
import { Button } from '@new-components/elements';
import { CheckIcon } from '@new-components/shapes';

import { BankAccountValidationProps } from './types';
import { bankAccountVerificationCx } from './styles';

const BankAccountValidation = (props: BankAccountValidationProps) => {
  const { onCancel, onVerify, isOpen, isLoading } = props;

  const { watch } = useFormContext();

  return (
    <BottomSheet
      title='Konfirmasi Bank'
      display={isOpen}
      onClose={onCancel}
      loading={isLoading}
      noAction
    >
      <div className={bankAccountVerificationCx}>
        <div className='bank-wrapper'>
          <Typography type='body'>Nama Bank</Typography>
          <Typography type='body' bold>
            {watch('bankName')}
          </Typography>
          <Typography type='body'>Nomor Rekening</Typography>
          <Typography type='body' bold>
            {watch('bankAccountNumber')}
          </Typography>
        </div>
        <div className='warning-box'>
          <Typography type='heading' headingType={6} fontSize='16px' bold>
            Sebelum konfirmasi, perhatikan hal berikut:
          </Typography>
          <div>
            <CheckIcon />
            <span>Pastikan nomor rekening miliki pribadi</span>
          </div>
          <div>
            <CheckIcon />
            <span>Pastikan rekening ini juga terdaftar di Grab</span>
          </div>
          <div>
            <CheckIcon />
            <span>
              Pastikan ada transaksi di rekeningmu dalam 3 bulan terakhir
            </span>
          </div>
        </div>

        <div className='action'>
          <Button
            variant='secondary'
            loading={isLoading || false}
            onClick={onCancel}
            fullWidth
          >
            Batal
          </Button>
          <Button loading={isLoading || false} onClick={onVerify} fullWidth>
            Konfirmasi
          </Button>
        </div>
      </div>
    </BottomSheet>
  );
};

export default BankAccountValidation;
